// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'mensagensTeclado.title': 'Mensagens Teclado',
    'mensagensTeclado.eyebrow': 'Logística',
    'mensagensTeclado.hint': 'Uma linha por macro digitada no teclado do rastreador.',
    'mensagensTeclado.empty': 'Nenhuma mensagem no período.',
    'mensagensTeclado.count': '{{count}} mensagens',
    'mensagensTeclado.senhaAviso': 'Para bater a macro o motorista precisa estar identificado no terminal, com a senha dele.',
    'mensagensTeclado.col.placa': 'Placa',
    'mensagensTeclado.col.motorista': 'Motorista',
    'mensagensTeclado.col.tipo': 'Tipo de macro',
    'mensagensTeclado.col.informacao': 'Informação enviada',
    'mensagensTeclado.col.enviadaEm': 'Data e hora do envio',
    'mensagensTeclado.col.local': 'Localização',
    'mensagensTeclado.tipo.notaFiscal': 'Nota Fiscal',
    'mensagensTeclado.tipo.veiculoVazio': 'Veículo Vazio',
    'mensagensTeclado.tipo.todos': 'Todas',
    'mensagensTeclado.filtro.placa': 'Placa',
    'mensagensTeclado.filtro.motorista': 'Motorista',
    'mensagensTeclado.filtro.tipo': 'Tipo de macro',
    'mensagensTeclado.semMotorista': 'Sem de para no cadastro',
    'mensagensTeclado.semMotoristaDica': 'A macro veio com o motorista {{id}} do rastreador, que ainda não casa com nenhuma pessoa do HUB.',
    'mensagensTeclado.abrirMapa': 'Abrir no Google Maps',
    'mensagensTeclado.semLocal': 'Mensagem sem coordenada',
    'mensagensTeclado.notaNumero': 'Nota {{numero}}',
    'mensagensTeclado.col.dupla': 'Dupla',
    'mensagensTeclado.col.status': 'Status',
    'mensagensTeclado.filtro.dupla': 'Dupla',
    'mensagensTeclado.filtro.buscarDupla': 'Buscar dupla',
    'mensagensTeclado.filtro.status': 'Status',
    'mensagensTeclado.semDupla': 'Sem dupla',
    'mensagensTeclado.status.pendente': 'Pendente',
    'mensagensTeclado.status.conferido': 'Conferido',
    'mensagensTeclado.status.todos': 'Todos',
    'mensagensTeclado.status.alteradoPor': '{{status}} por {{nome}} em {{quando}}',
    'mensagensTeclado.aba.mensagens': 'Mensagens',
    'mensagensTeclado.aba.conferencia': 'Conferência das viagens',
    'mensagensTeclado.conf.hint': 'Viagens da Frente de Trabalho a partir de {{inicio}}, depois de fechadas. Toda viagem deve uma macro de nota fiscal e uma de veículo vazio, e só aparece o que faltou.',
    'mensagensTeclado.conf.viagens': 'Viagens conferidas',
    'mensagensTeclado.conf.semNota': 'Sem macro de nota',
    'mensagensTeclado.conf.semVazio': 'Sem macro de vazio',
    'mensagensTeclado.conf.emDia': 'Em dia',
    'mensagensTeclado.conf.emDiaHint': '{{count}} viagens com as duas macros',
    'mensagensTeclado.conf.ranking': 'Ranking por motorista',
    'mensagensTeclado.conf.rankingVazio': 'Nenhum motorista com falta no período.',
    'mensagensTeclado.conf.faltas': 'Macros que faltaram',
    'mensagensTeclado.conf.vazio': 'Nenhuma falta no período.',
    'mensagensTeclado.conf.filtro.falta': 'Falta',
    'mensagensTeclado.conf.falta.todas': 'Todas',
    'mensagensTeclado.conf.falta.nota_fiscal': 'Sem nota fiscal',
    'mensagensTeclado.conf.falta.veiculo_vazio': 'Sem veículo vazio',
    'mensagensTeclado.conf.col.dia': 'Data',
    'mensagensTeclado.conf.col.frente': 'Frente',
    'mensagensTeclado.conf.col.carga': 'Carga',
    'mensagensTeclado.conf.col.falta': 'Falta',
    'mensagensTeclado.conf.col.janela': 'Janela conferida',
    'mensagensTeclado.conf.col.motorista': 'Motorista',
    'mensagensTeclado.conf.col.placas': 'Placas',
    'mensagensTeclado.conf.col.viagens': 'Viagens',
    'mensagensTeclado.conf.col.semNota': 'Sem nota',
    'mensagensTeclado.conf.col.semVazio': 'Sem vazio',
    'mensagensTeclado.conf.col.total': 'Total',
    'mensagensTeclado.conf.janela': '{{de}} a {{ate}}',
    'mensagensTeclado.conf.semMotorista': 'Sem motorista',
    'mensagensTeclado.conf.count': '{{count}} faltas',
  },
  en: {
    'mensagensTeclado.title': 'Keyboard messages',
    'mensagensTeclado.eyebrow': 'Logistics',
    'mensagensTeclado.hint': 'One row per macro typed on the tracker keyboard.',
    'mensagensTeclado.empty': 'No messages in this period.',
    'mensagensTeclado.count': '{{count}} messages',
    'mensagensTeclado.senhaAviso': 'To send a macro the driver must be signed in on the terminal with their password.',
    'mensagensTeclado.col.placa': 'Plate',
    'mensagensTeclado.col.motorista': 'Driver',
    'mensagensTeclado.col.tipo': 'Macro type',
    'mensagensTeclado.col.informacao': 'Information sent',
    'mensagensTeclado.col.enviadaEm': 'Sent on',
    'mensagensTeclado.col.local': 'Location',
    'mensagensTeclado.tipo.notaFiscal': 'Invoice',
    'mensagensTeclado.tipo.veiculoVazio': 'Empty vehicle',
    'mensagensTeclado.tipo.todos': 'All',
    'mensagensTeclado.filtro.placa': 'Plate',
    'mensagensTeclado.filtro.motorista': 'Driver',
    'mensagensTeclado.filtro.tipo': 'Macro type',
    'mensagensTeclado.semMotorista': 'Not mapped to a person',
    'mensagensTeclado.semMotoristaDica': 'The macro came from tracker driver {{id}}, not yet mapped to a HUB person.',
    'mensagensTeclado.abrirMapa': 'Open in Google Maps',
    'mensagensTeclado.semLocal': 'Message without coordinates',
    'mensagensTeclado.notaNumero': 'Invoice {{numero}}',
    'mensagensTeclado.col.dupla': 'Pair',
    'mensagensTeclado.col.status': 'Status',
    'mensagensTeclado.filtro.dupla': 'Pair',
    'mensagensTeclado.filtro.buscarDupla': 'Search pair',
    'mensagensTeclado.filtro.status': 'Status',
    'mensagensTeclado.semDupla': 'No pair',
    'mensagensTeclado.status.pendente': 'Pending',
    'mensagensTeclado.status.conferido': 'Checked',
    'mensagensTeclado.status.todos': 'All',
    'mensagensTeclado.status.alteradoPor': '{{status}} by {{nome}} on {{quando}}',
    'mensagensTeclado.aba.mensagens': 'Messages',
    'mensagensTeclado.aba.conferencia': 'Trip check',
    'mensagensTeclado.conf.hint': 'Work front trips from {{inicio}} on, once closed. Every trip owes an invoice macro and an empty vehicle macro, and only what is missing shows up.',
    'mensagensTeclado.conf.viagens': 'Trips checked',
    'mensagensTeclado.conf.semNota': 'No invoice macro',
    'mensagensTeclado.conf.semVazio': 'No empty macro',
    'mensagensTeclado.conf.emDia': 'Up to date',
    'mensagensTeclado.conf.emDiaHint': '{{count}} trips with both macros',
    'mensagensTeclado.conf.ranking': 'Ranking by driver',
    'mensagensTeclado.conf.rankingVazio': 'No driver missing macros in the period.',
    'mensagensTeclado.conf.faltas': 'Missing macros',
    'mensagensTeclado.conf.vazio': 'Nothing missing in the period.',
    'mensagensTeclado.conf.filtro.falta': 'Missing',
    'mensagensTeclado.conf.falta.todas': 'All',
    'mensagensTeclado.conf.falta.nota_fiscal': 'No invoice',
    'mensagensTeclado.conf.falta.veiculo_vazio': 'No empty vehicle',
    'mensagensTeclado.conf.col.dia': 'Date',
    'mensagensTeclado.conf.col.frente': 'Work front',
    'mensagensTeclado.conf.col.carga': 'Load',
    'mensagensTeclado.conf.col.falta': 'Missing',
    'mensagensTeclado.conf.col.janela': 'Window checked',
    'mensagensTeclado.conf.col.motorista': 'Driver',
    'mensagensTeclado.conf.col.placas': 'Plates',
    'mensagensTeclado.conf.col.viagens': 'Trips',
    'mensagensTeclado.conf.col.semNota': 'No invoice',
    'mensagensTeclado.conf.col.semVazio': 'No empty',
    'mensagensTeclado.conf.col.total': 'Total',
    'mensagensTeclado.conf.janela': '{{de}} to {{ate}}',
    'mensagensTeclado.conf.semMotorista': 'No driver',
    'mensagensTeclado.conf.count': '{{count}} missing',
  },
  es: {
    'mensagensTeclado.title': 'Mensajes de teclado',
    'mensagensTeclado.eyebrow': 'Logística',
    'mensagensTeclado.hint': 'Una fila por macro escrita en el teclado del rastreador.',
    'mensagensTeclado.empty': 'Ningún mensaje en el período.',
    'mensagensTeclado.count': '{{count}} mensajes',
    'mensagensTeclado.senhaAviso': 'Para enviar la macro el conductor debe estar identificado en el terminal con su contraseña.',
    'mensagensTeclado.col.placa': 'Placa',
    'mensagensTeclado.col.motorista': 'Conductor',
    'mensagensTeclado.col.tipo': 'Tipo de macro',
    'mensagensTeclado.col.informacao': 'Información enviada',
    'mensagensTeclado.col.enviadaEm': 'Fecha y hora del envío',
    'mensagensTeclado.col.local': 'Ubicación',
    'mensagensTeclado.tipo.notaFiscal': 'Factura',
    'mensagensTeclado.tipo.veiculoVazio': 'Vehículo vacío',
    'mensagensTeclado.tipo.todos': 'Todas',
    'mensagensTeclado.filtro.placa': 'Placa',
    'mensagensTeclado.filtro.motorista': 'Conductor',
    'mensagensTeclado.filtro.tipo': 'Tipo de macro',
    'mensagensTeclado.semMotorista': 'Sin vínculo en el registro',
    'mensagensTeclado.semMotoristaDica': 'La macro llegó con el conductor {{id}} del rastreador, aún sin vínculo con una persona del HUB.',
    'mensagensTeclado.abrirMapa': 'Abrir en Google Maps',
    'mensagensTeclado.semLocal': 'Mensaje sin coordenada',
    'mensagensTeclado.notaNumero': 'Factura {{numero}}',
    'mensagensTeclado.col.dupla': 'Pareja',
    'mensagensTeclado.col.status': 'Estado',
    'mensagensTeclado.filtro.dupla': 'Pareja',
    'mensagensTeclado.filtro.buscarDupla': 'Buscar pareja',
    'mensagensTeclado.filtro.status': 'Estado',
    'mensagensTeclado.semDupla': 'Sin pareja',
    'mensagensTeclado.status.pendente': 'Pendiente',
    'mensagensTeclado.status.conferido': 'Revisado',
    'mensagensTeclado.status.todos': 'Todos',
    'mensagensTeclado.status.alteradoPor': '{{status}} por {{nome}} el {{quando}}',
    'mensagensTeclado.aba.mensagens': 'Mensajes',
    'mensagensTeclado.aba.conferencia': 'Control de los viajes',
    'mensagensTeclado.conf.hint': 'Viajes del Frente de Trabajo desde {{inicio}}, después de cerrados. Todo viaje debe una macro de nota fiscal y una de vehículo vacío, y solo aparece lo que faltó.',
    'mensagensTeclado.conf.viagens': 'Viajes controlados',
    'mensagensTeclado.conf.semNota': 'Sin macro de nota',
    'mensagensTeclado.conf.semVazio': 'Sin macro de vacío',
    'mensagensTeclado.conf.emDia': 'Al día',
    'mensagensTeclado.conf.emDiaHint': '{{count}} viajes con las dos macros',
    'mensagensTeclado.conf.ranking': 'Ranking por conductor',
    'mensagensTeclado.conf.rankingVazio': 'Ningún conductor con faltas en el período.',
    'mensagensTeclado.conf.faltas': 'Macros que faltaron',
    'mensagensTeclado.conf.vazio': 'Ninguna falta en el período.',
    'mensagensTeclado.conf.filtro.falta': 'Falta',
    'mensagensTeclado.conf.falta.todas': 'Todas',
    'mensagensTeclado.conf.falta.nota_fiscal': 'Sin nota fiscal',
    'mensagensTeclado.conf.falta.veiculo_vazio': 'Sin vehículo vacío',
    'mensagensTeclado.conf.col.dia': 'Fecha',
    'mensagensTeclado.conf.col.frente': 'Frente',
    'mensagensTeclado.conf.col.carga': 'Carga',
    'mensagensTeclado.conf.col.falta': 'Falta',
    'mensagensTeclado.conf.col.janela': 'Ventana controlada',
    'mensagensTeclado.conf.col.motorista': 'Conductor',
    'mensagensTeclado.conf.col.placas': 'Placas',
    'mensagensTeclado.conf.col.viagens': 'Viajes',
    'mensagensTeclado.conf.col.semNota': 'Sin nota',
    'mensagensTeclado.conf.col.semVazio': 'Sin vacío',
    'mensagensTeclado.conf.col.total': 'Total',
    'mensagensTeclado.conf.janela': '{{de}} a {{ate}}',
    'mensagensTeclado.conf.semMotorista': 'Sin conductor',
    'mensagensTeclado.conf.count': '{{count}} faltas',
  },
}
